import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteRequest } from 'utils/api/apiRequest'

export const useRevokeToken = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => deleteRequest(`/oauth2/revoke`),
    onSuccess: () => {
      queryClient.resetQueries(['all'])
    },
    onError: () => {},
    retry: false,
  })
}
